(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/mini/assets/javascripts/models/statisticsmini.js') >= 0) return;  svs.modules.push('/components/statistics/mini/assets/javascripts/models/statisticsmini.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.components = svs.components || {};
  svs.components.models = svs.components.models || {};

  var log = new svs.core.log.Logger('svs.statistics.statisticsmini');

  var NO_OF_FORM_MATCHES = 5,
    SPORTS = {
      SOCCER: 1000002,
      HOCKEY: 1000003
    };

  svs.components.models.StatisticsMini = Backbone.Model.extend({
    url: function() {
      if (_.size(this.paths) > 1) {
        if (
          !!this.paths.hometeamlatest &&
          !!this.paths.awayteamlatest &&
          !!this.paths.draws
        ) {
          return svs.core.jupiter.multiFetch([
            this.paths.ministatistics,
            this.paths.draws,
            this.paths.hometeamlatest,
            this.paths.awayteamlatest
          ]);
        } else if (!!this.paths.hometeamlatest && !!this.paths.awayteamlatest) {
          return svs.core.jupiter.multiFetch([
            this.paths.ministatistics,
            this.paths.hometeamlatest,
            this.paths.awayteamlatest
          ]);
        } else if (this.paths.draws) {
          return svs.core.jupiter.multiFetch([
            this.paths.ministatistics,
            this.paths.draws
          ]);
        }
      } else {
        return svs.core.jupiter.url() + this.paths.ministatistics;
      }
    },

    defaults: {
      matchId: 0,
      isLive: false,
      fetched: false,
      statistics: null,
      preserve: false,
      isInitialized: false
    },

    initialize: function(options) {
      options = _.extend({}, options);

      if (!options.matchId) {
        log.warn('No matchId provided.', this);
      }

      this.matchId = options.matchId;
      this.drawsFetched = false;
      this.lastMatchesFetched = false;


      this.initPaths();
      this.initDrawsModel();
      this.updateModel();
    },

    onStatusChange: function(model, status) {
      if (this.isFetchTotalSavedGoalsPercentCollections(model, status)) {
        this.stopListening(this, 'change:status');
        this.initTotalSavedGoalsPercentCollections();
      }
    },

    isFetchTotalSavedGoalsPercentCollections: function(model, status) {
      var sportId = model.get('sport') && model.get('sport').id;

      status = status || 0;

      if (
        model.getTemplateFunction('hasStarted', status) ||
        sportId !== SPORTS.HOCKEY
      ) {
        return false;
      }
      if (!this.totalSavedGoalsPercentCollections) {
        return true;
      }
    },

    initPaths: function() {
      var path = '/sport/1/matches/' + this.matchId;

      this.paths = {
        ministatistics: path + '/ministatistics'
      };

      if (!this.get('omitDrawInfo')) {
        this.paths.draws = path + '/draws';
        this.drawsFetched = true;
      }

      if (
        !this.get('isLive') &&
        (!!this.get('homeTeamId') && !!this.get('awayTeamId'))
      ) {
        var latestMatchesQuery = '/lastmatches?count=' + NO_OF_FORM_MATCHES;
        this.paths.hometeamlatest =
          '/sport/1/teams/' + this.get('homeTeamId') + latestMatchesQuery;
        this.paths.awayteamlatest =
          '/sport/1/teams/' + this.get('awayTeamId') + latestMatchesQuery;
        this.lastMatchesFetched = true;
      }
    },

    initDrawsModel: function() {
      var self = this;

      this.draws = new svs.statistics.models.Draws({
        matchId: this.matchId
      });

      this.listenTo(this.draws, 'change', function() {
        self.set('oddsetDraws', this.draws.getDraws());
      });
    },

    update: function(param) {
      if (!param) {
        return;
      }

      if (svs.statistics && svs.statistics.socketCache) {
        svs.statistics.socketCache.add('MINI_STATISTICS', param.statistics);
      }

      var attrs = this.parse(param, {});
      this.set(attrs); 

      log.debug(
        moment().format('YYYY-MM-DD HH:mm:ss:SSS'),
        'Updated model with socket data. Changed values:',
        this.changed
      );
    },

    updateModel: function() {
      var _self = this;
      this.fetch({
        success: function() {
          if (
            !_self.get('error') &&
            _self.getTemplateFunction('subscribeMatch', {
              time: _self.get('startTime'),
              status: _self.get('status')
            })
          ) {
            log.debug('Start subscription...');
            _self.trigger('change', _self);
            _self.draws.startPush();
            _self.startPush();
          }
        },
        error: function() {
          _self.set({ fetched: true }, { silent: true });
          _self.set('error', true, { silent: true });
          _self.trigger('change', _self);
        }
      });
    },

    parse: function(response) {
      var currentHomeTeamId = this.get('homeTeamId');
      var currentAwayTeamId = this.get('awayTeamId');

      if (!response) {
        log.warn('Invalid response.', response);
        return {};
      }

      var isMultiFetch = !!response.responses,
        statisticsResponse,
        drawsResponse,
        i;

      if (isMultiFetch) {
        statisticsResponse = response.responses[0];

        if (this.drawsFetched) {
          drawsResponse = _.find(response.responses, function(response) {
            return response.drawInfo;
          });
        }

        if (statisticsResponse.error) {
          log.warn('Error when fetching ministatistics', statisticsResponse);
          this.set({ error: true, fetched: true });
          return {};
        }

        if (this.draws && drawsResponse) {
          this.draws.set(drawsResponse, { silent: true });
          statisticsResponse.statistics.oddsetDraws = this.draws.getDraws();
        }

        if (this.lastMatchesFetched) {
          var lastMatchesResponse = _.filter(response.responses, function(
            response
          ) {
            return response.result;
          });

          if (
            svs.utils.ns.isNamespace(
              'statistics.participants',
              statisticsResponse
            ) &&
            lastMatchesResponse &&
            lastMatchesResponse.length > 1 &&
            (!lastMatchesResponse[0].error && !lastMatchesResponse[1].error)
          ) {
            for (
              i = 0;
              i < statisticsResponse.statistics.participants.length;
              i++
            ) {
              var history = svs.utils.result.getLatestAndTrend(
                lastMatchesResponse[i],
                i,
                currentHomeTeamId,
                currentAwayTeamId
              );
              statisticsResponse.statistics.participants[i].latest =
                history.latest;
              statisticsResponse.statistics.participants[
                i
              ].trend = svs.utils.result.getCurrentTrend(history.trend);
              statisticsResponse.statistics.participants[i].latest = _.first(
                statisticsResponse.statistics.participants[i].latest,
                NO_OF_FORM_MATCHES
              );
            }
          }
        }
      } else {
        statisticsResponse = response;
        if (
          _.isArray(this.get('participants')) &&
          _.isArray(statisticsResponse.statistics.participants)
        ) {
          for (i = 0; i < this.get('participants').length; i++) {
            statisticsResponse.statistics.participants[i].latest = this.get(
              'participants'
            )[i].latest;
            statisticsResponse.statistics.participants[i].trend = this.get(
              'participants'
            )[i].trend;
          }
        }
      }

      var statistics = statisticsResponse.statistics;

      this.set({ error: false, fetched: true }, { silent: true });

      if (statistics) {
        if (_.has(statistics, 'sport')) {
          this.set('sport', statistics.sport, { silent: true });
          if (statistics.sport.id === svs.statistics.constants.TROTTING) {
            if (
              svs.statistics.data.overrideTrotting1X2Headers &&
              Object.prototype.hasOwnProperty.call(
                svs.statistics.data.overrideTrotting1X2Headers,
                statistics.matchId
              )
            ) {
              this.set(
                'overrideHeaders',
                svs.statistics.data.overrideTrotting1X2Headers[
                  statistics.matchId
                ],
                { silent: true }
              );
            }
          }
        } else {
          log.warn('No available sport object.', response);
          return false;
        }

        if (_.has(statistics, 'league') && _.isObject(statistics.league)) {
          statistics.league = this.getTemplateFunction(
            'formatTable',
            statistics.league
          );
        }

        if (
          _.has(statistics, 'matchEvents') &&
          _.isObject(statistics.matchEvents)
        ) {
          statistics.matchEvents = this.getTemplateFunction(
            'groupEvents',
            statistics
          );
          statistics.matchEvents = statistics.matchEvents
            ? statistics.matchEvents
            : [];
        } else {
          statistics.matchEvents = [];
        }

        var _self = this;
        if (!this.theme) {
          this.theme = new svs.sport.themeLoader({
            sport: statistics.sport.id
          });
        }
        this.theme.load(function(template, init) {
          if (init) {
            if (init('isEnded', statistics.status)) {
              _self.stopPush();
            }
          }
        }, 'init');

        return statistics;
      }
      return false;
    },
    getTemplateFunction: function(func, data) {
      var returner = false;

      if (!this.theme) {
        this.initTheme();
      }

      if (this.theme) {
        this.theme.load(function(template, init) {
          if (init) {
            returner = init(func, data);
          }
        }, 'init');
      }
      return returner;
    },

    initTheme: function() {
      if (this.get('sport')) {
        var sport = this.get('sport');
        if (!this.theme) {
          this.theme = new svs.sport.themeLoader({
            sport: sport.id
          });
        }
      }
      if (!this.theme) {
        log.info('theme not found');
        this.clear({ silent: true });
      }
    },

    startPush: function(sendInitialUpdate) {
      var self = this;

      if (this.subscribed) {
        return;
      }

      window.requestIdleCallback(function() {
        try {
          svs.core.socket.subscribe(
            self.paths.ministatistics,
            self.update,
            self,
            !!sendInitialUpdate
          );
          self.subscribed = true;
        } catch (e) {
          log.error(e.message);
        }
      });
    },

    stopPush: function() {
      var self = this;

      window.requestIdleCallback(function() {
        try {
          if (self.subscribed) {
            svs.core.socket.unsubscribe(self.paths.ministatistics, self.update);
            self.subscribed = false;
          }

          if (self.draws) {
            self.draws.stopPush();
          }
        } catch (e) {
          log.error(e.message);
        }
      });
    },

    initTotalSavedGoalsPercentCollections: function() {
      var homeTeamId = this.get('participants')[0].team.id,
        awayTeamId = this.get('participants')[1].team.id,
        self = this;

      var leagueId = this.get('leagueId');

      this.totalSavedGoalsPercentCollections = {
        home: new svs.components.collections.TotalSavedGoalsPercent([], {
          leagueId: leagueId,
          teamId: homeTeamId
        }),
        away: new svs.components.collections.TotalSavedGoalsPercent([], {
          leagueId: leagueId,
          teamId: awayTeamId
        })
      };

      this.listenTo(
        this.totalSavedGoalsPercentCollections.home,
        'sync',
        function() {
          self.onTotalSavedGoalsPercentModelChange('home');
          self.stopListening(this.totalSavedGoalsPercentCollections.home);
        }
      );

      this.listenTo(
        this.totalSavedGoalsPercentCollections.away,
        'sync',
        function() {
          self.onTotalSavedGoalsPercentModelChange('away');
          self.stopListening(this.totalSavedGoalsPercentCollections.away);
        }
      );

      this.totalSavedGoalsPercentCollections.home.fetch();
      this.totalSavedGoalsPercentCollections.away.fetch();
    },

    onTotalSavedGoalsPercentModelChange: function(team) {
      var collection = this.totalSavedGoalsPercentCollections[team];

      this.stopListening(collection);

      if (!collection.length) {
        return;
      }

      this.set('totalSavedGoalsPercent' + team, collection.toJSON(), {
        silent: true
      });

      this.trigger('change', this);
    }
  });
})(Backbone, _, svs);

 })(window);